var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-meal-log-meal',_vm._g({attrs:{"state":_vm.state,"showText":_vm.showText,"limitText":_vm.limitText},on:{"clicked":function($event){return _vm.clicked()}}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }